// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: '8px 16px',
    },
    container: {
      padding: '8px 24px',

      margin: theme.spacing(0),
    },
    closeIconContainer: {
      justifyContent: 'flex-start',
    },
  }),
);

export default useStyles;
